module.exports = __webpack_public_path__ + "js/1.21e8e19c.worker.js"